import { render } from "./HistoricoAjusteModal.vue?vue&type=template&id=eba791e4"
import script from "./HistoricoAjusteModal.vue?vue&type=script&lang=js"
export * from "./HistoricoAjusteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__